import React, { useState } from 'react';
import { FaSearch } from 'react-icons/fa'; 
import './SearchTab.css'; // Import the CSS file

const SearchTab = ({ onSearch }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [query, setQuery] = useState("");

  const handleToggle = () => {
    setIsOpen(!isOpen); 
  };

  const handleChange = (e) => {
    setQuery(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch(query);
    setIsOpen(false); 
  };

  return (
    <div className="search-container">
      {/* Search Icon */}
      <FaSearch onClick={handleToggle} className="search-icon" />
      
      {/* Search Form */}
      {isOpen && (
        <form onSubmit={handleSubmit} className="search-form">
          <input
            type="text"
            value={query}
            onChange={handleChange}
            placeholder="Search..."
            className="search-input"
          />
          <button type="submit" className="search-button">Search</button>
        </form>
      )}
    </div>
  );
};

export default SearchTab;
